import styles from './index.module.less';
import FJLocalStore from '@src/store/FJLocalStore';
import FJHistoryItem from '@src/components/FJModals/FJPublishHistoryModal/FJHistoryItem.tsx';
import FJModalClose from '@src/components/FJModals/FJModalClose/FJModalClose.tsx';
import FJS3Config from '@src/config/FJS3Config';

interface Props {
    historyList: any[];
    onClose: () => void;
}

const FJPublishHistory = ({ historyList, onClose }: Props) => {
    const height = Math.min(530, 77 * historyList.length + 78 + 30 + 28);

    return (
        <div className={styles.box} style={{ height: height }}>
            <FJModalClose onClick={onClose} />
            <p className={styles.header_title}>{FJLocalStore._('post-history')}</p>
            <div className={styles.scroller}>
                <div className={styles.list}>
                    {historyList.map((item, index) => {
                        const { type, name, publishTime, shareUrl, avatarUrl } = item;
                        return (
                            <FJHistoryItem
                                key={index}
                                avatarUrl={avatarUrl ? FJS3Config.S3_NOT_CATCH_HOST + avatarUrl : ''}
                                name={name}
                                time={publishTime}
                                shareType={type}
                                shareUrl={shareUrl}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default FJPublishHistory;
